import { useState, useEffect, useRef } from 'react';
import { now } from '@/utils/format';

export function useFpsMeter(running: boolean): number {
  const [fps, setFps] = useState(0);
  const rafId = useRef(0);
  const ema = useRef(0);

  useEffect(() => {
    if (!running) {
      setFps(0);
      return;
    }
    let frames = 0;
    let last = now();
    ema.current = 0;

    function loop(t: number) {
      frames++;
      const dt = t - last;
      if (dt >= 500) {
        const inst = (frames * 1000) / dt;
        ema.current = ema.current ? ema.current * 0.8 + inst * 0.2 : inst;
        setFps(ema.current);
        frames = 0;
        last = t;
      }
      rafId.current = requestAnimationFrame(loop);
    }
    rafId.current = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(rafId.current);
  }, [running]);

  return fps;
}
